export const MANTA_VIDEO_COMPONENTS_SET_DATA_LOADING_STATE =
  'MANTA_VIDEO_COMPONENTS_SET_DATA_LOADING_STATE';
export const MANTA_VIDEO_COMPONENTS_SET_REQUEST_LOADING_STATE =
  'MANTA_VIDEO_COMPONENTS_SET_REQUEST_LOADING_STATE';
export const MANTA_VIDEO_COMPONENTS_SET_ERROR = 'MANTA_VIDEO_COMPONENTS_SET_ERROR';
export const MANTA_VIDEO_COMPONENTS_RESET_ERROR = 'MANTA_VIDEO_COMPONENTS_RESET_ERROR';
export const MANTA_VIDEO_COMPONENTS_SET_DATA = 'MANTA_VIDEO_COMPONENTS_SET_DATA';
export const MANTA_VIDEO_COMPONENTS_SET_REMOVE_ITEM_FROM_STATE =
  'MANTA_VIDEO_COMPONENTS_SET_REMOVE_ITEM_FROM_STATE';
